import { render, staticRenderFns } from "./emailverify.vue?vue&type=template&id=382d35a3&"
import script from "./emailverify.vue?vue&type=script&lang=js&"
export * from "./emailverify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports